import { render } from "./CampaignPeriodList.vue?vue&type=template&id=0fe72442&scoped=true"
import script from "./CampaignPeriodList.vue?vue&type=script&lang=js"
export * from "./CampaignPeriodList.vue?vue&type=script&lang=js"

import "./CampaignPeriodList.vue?vue&type=style&index=0&id=0fe72442&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fe72442"],['__file',"src/components/CampaignPeriodList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0fe72442"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0fe72442', __exports__)) {
    api.reload('0fe72442', __exports__)
  }
  
  module.hot.accept("./CampaignPeriodList.vue?vue&type=template&id=0fe72442&scoped=true", () => {
    api.rerender('0fe72442', render)
  })

}


export default __exports__